import * as fileUtils from 'utils/file';
import ItemView from './ItemView';

import word from 'assets/images/document.png';
import unknown from 'assets/images/document.png';
import sound from 'assets/images/document.png';
import film from 'assets/images/document.png';
import zip from 'assets/images/document.png';
import photo from 'assets/images/document.png';
import folder from 'assets/images/folder.png';
import user from 'assets/images/user.svg';
import survey from 'assets/images/form.png';
import { item_createNewDocument } from 'store/providers/providerSlice';
import {
  IComponentProps as IComponentBaseProps,
  IComponentState as IComponentBaseState,
} from './ItemView';
import { IProviderItemViewWithData } from '../../../../store/providers/providerTypes';
import { checkFileFormat } from '../../../../utils/check-file-type/checkFileFormat';
import { blue } from '../../../../utils/style/colors';
import i18n from '../../../../i18n';
import { IUsers } from '../../../../store/store';

interface IComponentProps extends IComponentBaseProps {
  users?: IUsers;
}

interface IComponentState extends IComponentBaseState {
  progress: number;
}

export const itemImage = {
  word: word,
  unknown: unknown,
  sound: sound,
  film: film,
  zip: zip,
  picture: photo,
  folder: folder,
  profile: user,
  survey: survey,
};

class DocumentView extends ItemView<IComponentProps, IComponentState> {
  deleteItemTitle(name: string) {
    return i18n.t('deleteDocumentTitle', { ns: 'documentManager', name });
  }

  deleteItemMessage(name: string) {
    return i18n.t('deleteDocumentMessage', { ns: 'documentManager', name });
  }

  onOpenFunction(item: IProviderItemViewWithData, isNewTab: boolean) {
    return (e: any) => {
      this.props.onOpenItem(
        item,
        'view',
        undefined,
        isNewTab || e.altKey || e.metaKey
      );
    };
    // return () => window.open(item.data.document.url);
  }

  getThumbnail() {
    const item = this.props.item;
    const iconType = checkFileFormat(item.data.document?.properties?.format);
    const iconColor = blue;
    return [iconType, iconColor];
  }

  handelConfirmCreatingNewItem(item: IProviderItemViewWithData) {
    item.data.name = this.nameInput.value;
    item.data.order = this.props.expectedOrder;
    fileUtils.fileURIToBlob(item.data.document.url, (blob: any) => {
      this.props.dispatch(
        item_createNewDocument({
          item: item.data,
          file: blob,
          setProgress: (progress) => {
            this.setState({
              progress: progress,
            });
          },
        })
      );
    });
  }

  newItemPlaceHolder() {
    return i18n.t('newDocumentPlaceholder', { ns: 'documentManager' });
  }

  newItemTitle() {
    return i18n.t('newDocumentTitle', { ns: 'documentManager' });
  }

  getProgressBar() {
    if (!this.state.progress || this.state.progress === 100) {
      return (
        <div className="progress">
          <div className="indeterminate" />
        </div>
      );
    }
    return (
      <div className="progress">
        <div
          className="determinate"
          style={{ width: this.state.progress + '%' }}
        />
      </div>
    );
  }
}

export default DocumentView;
